
export const name = "conversations-inbox-ui";
export const version = "dev";
